import { AbstractControl, ValidatorFn } from '@angular/forms';
import { findControl } from './form-builder-utils';
import { stringToCurrency } from 'common';

export function ssGreaterThanOrEqualControlAmount(
  relativeToControl: string,
  control?: string
): ValidatorFn {
  return (c: AbstractControl): { [key: string]: boolean } | null => {
    const number = tryGetNumericComponentValue(findControl(c, false, control));
    const relativeMin = tryGetNumericComponentValue(
      findControl(c, true, relativeToControl)
    );

    return relativeMin !== undefined &&
      number !== undefined &&
      number < relativeMin
      ? { relativeToMinAmount: true }
      : null;
  };
}

export function ssCurrencyMin(min: number, control?: string): ValidatorFn {
  return (c: AbstractControl): { [key: string]: boolean } | null => {
    const number = tryGetNumericComponentValue(findControl(c, false, control));
    return number !== undefined && number < min ? { min: true } : null;
  };
}

export function ssCurrencyMax(max: number, control?: string): ValidatorFn {
  return (c: AbstractControl): { [key: string]: boolean } | null => {
    const number = tryGetNumericComponentValue(findControl(c, false, control));
    return number !== undefined && number > max ? { max: true } : null;
  };
}

function tryGetNumericComponentValue(
  abstractControl: AbstractControl
): number | undefined {
  //safety check
  if (!abstractControl?.value) {
    return undefined;
  }

  const currentValue = abstractControl.value as string | number;

  // could pontentially already be a number if it comes from BE
  if (!Number.isNaN(Number(currentValue))) {
    return Number(currentValue);
  }

  return Number(stringToCurrency((abstractControl.value as string) ?? ''));
}
